import { type AppState } from '../../common/types';

export const getSearchResult = (state: AppState) => state.search?.posts;
